export class DeleteObservationItem {
  readonly type: string = "observation";
  id: number;

  constructor(id: number) {
    this.id = id;
  }
}

export class ObservationData {
  readonly type: string = "observation";
  classificatorCodeId?: number;
  comment?: string;
  conditionCodeId?: number;
  deviceId?: number;
  effectiveTime?: Date;
  feelingCodeId?: number;
  id?: number;
  insertTime?: Date;
  observationList?: ObservationData[];
  personId?: number;
  representerPersonId?: number;
  targetSite?: string;
  masterObservationId?: number;
  value?: string;
  valueTypeId?: number;
  valueUnitId?: number;
  conditionKey?: string;
  hasWeightHeight?: boolean;
  isLatest?: boolean;
  mmol?: string;
  mgdl?: string;
}
